/*
 * @Description: 下载文件
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-19 15:19:52
 */

/**
 * @description: 弹层并下载
 * @param {object} data 下载api的传参
 * @param {object} ajax 下载api
 * @return {*}
 */
const receiptDownload = function({
  data,
  ajax,
  projectName,
  tips = '文件已经在下载中心内进行生成,如需下载请前往下载中心'
}) {
  this.$prompt('请输入文件名', '统计报表下载', {
    closeOnClickModal: false,
    confirmButtonText: '保存',
    showCancelButton: false,
    inputValue: projectName,
    inputValidator(v) {
      if (!v.length) {
        return '文件名至少1个字符';
      } else if (v.length > 100) {
        return '文件名最多100个字符';
      } else if (!/^[A-Z|a-z|0-9\u4E00-\u9FA5|\-|_|:]{1,100}$/.test(v)) {
        return '请填写（汉字、数字、英文、-、_、:）做为文件名，至少一位';
      } else {
        return true;
      }
    },
    async beforeClose(action, instance, done) {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true;
        instance.confirmButtonText = '执行中...';
        try {
          await ajax({ ...data, downloadName: instance.inputValue });
          done();
        } catch (e) {}
        instance.confirmButtonText = '保存';
        instance.confirmButtonLoading = false;
      } else {
        done();
      }
    }
  })
    .then(async () => {
      this.$confirm(tips, '', {
        showCancelButton: false,
        showConfirmButton: false
      }).then(() => {});
    })
    .catch(() => {});
};
export default receiptDownload;
